<div class="relative">
    <mat-divider class="custom-mat-divider thin light menu"> </mat-divider>

    @if (this.separator().title; as separator) {
        <div
            class="absolute left-[50px] top-1/2 -translate-y-1/2 overflow-hidden whitespace-nowrap bg-(--sidebar-background-color,white) px-2 text-black text-opacity-40"
        >
            {{ separator }}
        </div>
    }
</div>
